
























import { Component } from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import ExtendedCompass from '@/components/ExtendedCompass.vue';

@Component({components: {ExtendedCompass}})
export default class CardCompassYearsNew extends CompanyMixin {
}
